import * as React from 'react';
import { scrollTo, withSiteData } from 'react-static';
import { connect } from 'react-redux';

import { SiteProps } from '../../SiteProps';
import FooterComponent from '../../components/Footer/Footer';
import { RootState } from '../../RootState';
import { Language } from '../Localization/localizationDuck';
import { RouteComponentProps, withRouter } from 'react-router';

interface StateProps {
  language: Language;
}

interface FooterProps extends StateProps, SiteProps, RouteComponentProps<{}> {}

const Footer: React.SFC<FooterProps> = ({ footerLocale, language, location: { pathname } }) => {
  const onLinkClick = (href: string) => pathname.startsWith(href) && scrollTo(0);

  return <FooterComponent locale={footerLocale[language]} onLinkClick={onLinkClick} />;
};

const mapStateToProps = (state: RootState) => ({
  language: state.localization.language,
});

export default withRouter(
  withSiteData(connect<StateProps, {}, {}, RootState>(mapStateToProps)(Footer)),
);



// WEBPACK FOOTER //
// /www/client/src/containers/Footer/Footer.tsx